/**
 *
 * CustomIcons
 *
 */

import React from 'react';
import Icon from '@ant-design/icons';

import * as definedIcons from './icons';

class CustomIcons extends React.PureComponent {
  // eslint-disable-line react/prefer-stateless-function

  renderSelectIcon = type => {
    switch (type) {
      case 'logo':
        return definedIcons.MainLogo;
      case 'logo-blue':
        return definedIcons.MainLogoBlue;
      case 'logo-white':
        return definedIcons.MainLogoWhite;
      case 'save':
        return definedIcons.SaveSvg;
      case 'user':
        return definedIcons.UserSvg;
      case 'upvote':
        return definedIcons.UpVote;
      case 'downvote':
        return definedIcons.DownVote;
      case 'casestudy':
        return definedIcons.UnitstudySvg;
      case 'casestudy-active':
        return definedIcons.UnitstudyActiveSvg;
      case 'parameters':
        return definedIcons.ParametersSvg;
      case 'comments':
        return definedIcons.CommentSvg;
      case 'feed':
        return definedIcons.FeedSvg;
      case 'feed-active':
        return definedIcons.FeedActiveSvg;
      case 'vote':
        return definedIcons.VoteSvg;
      case 'view':
        return definedIcons.ViewSvg;
      case 'home':
        return definedIcons.HomeSvg;
      case 'home-active':
        return definedIcons.HomeActiveSvg;
      case 'edit':
        return definedIcons.EditSvg;
      case 'verified':
        return definedIcons.VerifiedSvg;
      case 'verified-sky':
        return definedIcons.VerifiedSvgSky;
      case 'verified-white':
        return definedIcons.VerifiedWhiteSvg;
      case 'verified-white2':
        return definedIcons.VerifiedWhite2Svg;
      case 'arrow-right':
        return definedIcons.ArrowRightSvg;
      case 'arrow-left':
        return definedIcons.ArrowLeftSvg;
      case 'calendar':
        return definedIcons.CalendarSvg;
      case 'calendar-active':
        return definedIcons.CalendarActiveSvg;
      case 'photo':
        return definedIcons.PhotoSvg;
      case 'dots-vertical':
        return definedIcons.VerticalDotsSvg;
      case 'bookmark':
        return definedIcons.BookmarkSvg;
      case 'bookmark-white':
        return definedIcons.BookmarkWhiteSvg;
      case 'bookmarked':
        return definedIcons.BookmarkedSvg;
      case 'share':
        return definedIcons.ShareSvg;
      case 'share2':
        return definedIcons.Share2Svg;
      case 'microphone':
        return definedIcons.MicrophoneSvg;
      case 'microphone-active':
        return definedIcons.MicrophoneActiveSvg;
      case 'notifications-in-app':
        return definedIcons.NotificationSvg;
      case 'document':
        return definedIcons.DocumentSvg;
      case 'document-active':
        return definedIcons.DocumentActiveSvg;
      case 'person':
        return definedIcons.PersonSvg;
      case 'replay':
        return definedIcons.ReplaySvg;
      case 'registred':
        return definedIcons.RegistredSvg;
      case 'search':
        return definedIcons.SearchSvg;
      case 'time':
        return definedIcons.TimeSvg;
      case 'trophy':
        return definedIcons.TrophySvg;
      case 'pause':
        return definedIcons.PauseSvg;
      case 'close':
        return definedIcons.CloseSvg;
      case 'logout':
        return definedIcons.LogoutSvg;
      case 'academic':
        return definedIcons.AcademicSvg;
      case 'academic-active':
        return definedIcons.AcademicActiveSvg;
      case 'users':
        return definedIcons.UsersSvg;
      case 'book':
        return definedIcons.BookSvg;
      case 'book-active':
        return definedIcons.BookActiveSvg;
      case 'sort':
        return definedIcons.SortSvg;
      case 'filter':
        return definedIcons.FilterSvg;
      case 'filter-full':
        return definedIcons.FilterFullSvg;
      case 'absence':
        return definedIcons.AbsenceSvg;
      case 'quil':
        return definedIcons.QuilSvg;
      case 'absence-active':
        return definedIcons.AbsenceActiveSvg;
      case 'absence-checked':
        return definedIcons.AbsenceCheckedSvg;
      case 'absence-checked-active':
        return definedIcons.AbsenceCheckedActiveSvg;
      case 'medical':
        return definedIcons.MedicalSvg;
      case 'quill':
        return definedIcons.QuillSvg;
      case 'quill-active':
        return definedIcons.QuillActiveSvg;
      case 'sickness':
        return definedIcons.SicknessSvg;
      case 'no-absence':
        return definedIcons.NoAbsenceSvg;
      case 'sick-leave':
        return definedIcons.SickLeaveSvg;
      case 'virus':
        return definedIcons.VirusSvg;
      case 'star':
        return definedIcons.StarSvg;
      case 'star-empty':
        return definedIcons.StarEmptySvg;
      case 'delete':
        return definedIcons.DeleteSvg;
      case 'proof-photo':
        return definedIcons.ProofPhotoSvg;
      case 'proof-document':
        return definedIcons.ProofDocumentSvg;
      case 'no-proof':
        return definedIcons.NotProofSvg;
      case 'check-absent':
        return definedIcons.checkAbsent;
      case 'check-present':
        return definedIcons.checkPresent;
      case 'present-finish':
        return definedIcons.presentFinish;
      case 'school-simple':
        return definedIcons.schoolIconSimple;
      case 'school':
        return definedIcons.schoolIcon;
      case 'school-active':
        return definedIcons.schoolIconActive;
      case 'parent':
        return definedIcons.parentIcon;
      case 'parent-v2':
        return definedIcons.parentIconV2;
      case 'couple':
        return definedIcons.coupleIcon;
      case 'teacher':
        return definedIcons.teacherIcon;
      case 'letter-open':
        return definedIcons.letterOpenIcon;
      case 'letter-close':
        return definedIcons.letterCloseIcon;
      case 'letter-close-active':
        return definedIcons.letterCloseIconActive;
      case 'ordered-list':
        return definedIcons.orderedListIcon;
      case 'table':
        return definedIcons.TableOutlinedIcon;
      case 'table-active':
        return definedIcons.TableOutlinedActiveIcon;
      case 'garbage':
        return definedIcons.GarbageIcon;
      case 'group':
        return definedIcons.GroupIcon;
      case 'group-active':
        return definedIcons.GroupIconActive;
      case 'reply-left':
        return definedIcons.ReplyLeftIcon;
      case 'qrcode':
        return definedIcons.QrcodeOutlined;
      case 'stop':
        return definedIcons.StopIcon;
      case 'admin':
        return definedIcons.AdminIcon;
      case 'teacher-v2':
        return definedIcons.TeacherIconV2;
      case 'thumbnail':
        return definedIcons.ThumbnailIcon;
      case 'loop':
        return definedIcons.LoopSvg;
      default:
        return <span />;
    }
  };

  render() {
    return (
      <Icon
        className={this.props.className}
        style={this.props.style}
        component={this.renderSelectIcon(this.props.type)}
        onClick={this.props.onClick}
      />
    );
  }
}

export default CustomIcons;
